import React from 'react';
import { Card } from 'antd';
import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';
import { ProfitTrendPoint } from '../../../services/financeService';

interface ProfitTrendChartProps {
    trendData: ProfitTrendPoint[];
    loading: boolean;
}

export const ProfitTrendChart: React.FC<ProfitTrendChartProps> = ({ trendData, loading }) => {
    const getOption = () => {
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'shadow' }
            },
            legend: {
                data: ['销售额', '毛利润', '销量']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: trendData.map(item => dayjs(item.period).format('MM-DD')),
            },
            yAxis: [
                {
                    type: 'value',
                    name: '金额',
                },
                {
                    type: 'value',
                    name: '销量',
                    splitLine: { show: false }
                }
            ],
            series: [
                {
                    name: '销售额',
                    type: 'bar',
                    data: trendData.map(item => item.revenue),
                    itemStyle: { color: '#1890ff' }
                },
                {
                    name: '毛利润',
                    type: 'bar',
                    data: trendData.map(item => item.profit),
                    itemStyle: { color: '#52c41a' }
                },
                {
                    name: '销量',
                    type: 'line',
                    yAxisIndex: 1,
                    data: trendData.map(item => item.units),
                    itemStyle: { color: '#faad14' }
                }
            ]
        };
    };

    return (
        <Card title="利润趋势" bordered={false} loading={loading}>
            <ReactECharts option={getOption()} style={{ height: 300 }} />
        </Card>
    );
};
